var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.6667V21C16 23.2091 14.2092 25 12 25C9.7909 25 8.00004 23.2091 8.00004 21V19.6667M16 19.6667H8.00004M16 19.6667H20.7874C21.2974 19.6667 21.5536 19.6667 21.7602 19.597C22.1546 19.4639 22.4633 19.1542 22.5964 18.7597C22.6663 18.5524 22.6663 18.2953 22.6663 17.7813C22.6663 17.5563 22.6661 17.4438 22.6485 17.3366C22.6152 17.1339 22.5366 16.9418 22.4168 16.775C22.3535 16.6868 22.273 16.6064 22.1145 16.4478L21.5951 15.9284C21.4275 15.7608 21.3334 15.5335 21.3334 15.2965V10.3333C21.3334 5.17867 17.1547 0.999987 12 1C6.84539 1.00001 2.66671 5.17869 2.66671 10.3333V15.2966C2.66671 15.5336 2.57237 15.7608 2.4048 15.9284L1.88546 16.4477C1.72638 16.6068 1.64676 16.6867 1.58337 16.775C1.46358 16.9418 1.38424 17.1339 1.35097 17.3366C1.33337 17.4438 1.33337 17.5563 1.33337 17.7813C1.33337 18.2953 1.33337 18.5523 1.40331 18.7597C1.53637 19.1541 1.84644 19.4639 2.24093 19.597C2.44745 19.6667 2.70273 19.6667 3.21278 19.6667H8.00004",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.701a11a1d74a700bbf718f81f3cb0fec.svg";
export { ForwardRef as ReactComponent };